var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, html, LitElement } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';
import './wishlist-button';
import './product-modal';
import i18n from 'roddeh-i18n';
let ProductTileCompact = class ProductTileCompact extends LitElement {
    constructor() {
        super(...arguments);
        this.product = null;
        this.altshopID = '1';
        this.logUrl = null;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    firstUpdated() {
        this.logUrlListener();
    }
    logUrlListener() {
        if (this.logUrl === null) {
            return;
        }
        //nasluchuj kliknięć na linkach prowadzacych do strony produktu i wywołaj request do logUrl
        const productLinks = this.shadowRoot?.querySelectorAll('.prod-tile-compact a');
        if (typeof productLinks !== 'undefined') {
            productLinks.forEach((link) => {
                link.addEventListener('click', (e) => {
                    if (!this.logUrl) {
                        return;
                    }
                    if (!(e.currentTarget instanceof HTMLElement)) {
                        return;
                    }
                    const href = e.currentTarget.getAttribute('href');
                    if (href !== null) {
                        e.preventDefault();
                        fetch(this.logUrl)
                            .finally(() => {
                            window.location.href = href;
                        })
                            .catch((err) => {
                            console.error('Failed to log product click', err);
                            window.location.href = href;
                        });
                    }
                });
            });
        }
    }
    render() {
        let discountPercentage = 0;
        if (this.product !== null && this.product.price !== this.product.catalog_price) {
            discountPercentage = Math.ceil(100 - (this.product.price / this.product.catalog_price) * 100);
        }
        let cssJsMinHash = null;
        if (typeof window.__STATE__ !== 'undefined') {
            cssJsMinHash = window.__STATE__.system.css_js_min_hash;
        }
        const sku = this.product !== null
            ? typeof this.product.variant_sku !== 'undefined'
                ? this.product.variant_sku
                : this.product.sku
            : null;
        return html `
            <link
                rel="stylesheet"
                href="/css/layout/product-tile-compact.css${cssJsMinHash ? '?t=' + cssJsMinHash : ''}"
            />

            ${this.product !== null && sku !== null
            ? html `
                      <div
                          class="prod-tile-compact"
                          itemscope
                          itemtype="http://schema.org/Product"
                          @click="${this.goToProductPage}"
                      >
                          <a href="${this.product.navigation.alternate_url}">
                              <img
                                  src="${this.getImageUrl(this.product, '101x101')}"
                                  width="85"
                                  height="85"
                                  alt="${this.product.name}"
                              />
                              <meta itemprop="image" content="${this.getImageUrl(this.product, '500x500')}" />
                          </a>
                          <h3>
                              <a href="${this.product.navigation.alternate_url}">
                                  <span itemprop="name">
                                      ${this.product.name}
                                      ${this.product.count_attributes > 0 && this.activeColorName !== ''
                ? `- ${this.activeColorName}`
                : ''}
                                  </span>
                              </a>
                          </h3>

                          <meta itemprop="wrapperId" content="${this.product.id}" />
                          <meta itemprop="brand" content="Yves Rocher" />
                          <meta itemprop="sku" content="${sku}" />
                          <meta itemprop="url" content="${this.product.navigation.alternate_url}" />
                          <meta itemprop="description" content="${this.product.short_description}" />

                          <div class="details-container">
                              ${this.product.capacity
                ? html ` <div class="capacity">${this.product.capacity}</div> `
                : ''}
                              ${this.product.lowest_price_from_30d !== null
                ? html `
                                        <div class="omnibus">
                                            ${i18n('Previous price {price} ({percent})')
                    .replace('{price}', `${this.product.lowest_price_from_30d.toFixed(this.decimalDigits)} ${this.currency}`)
                    .replace('{percent}', this.omnibusPercentage(this.product.lowest_price_from_30d, this.product.price))}
                                        </div>
                                    `
                : ''}
                              ${this.product.price_per_unit !== null
                ? html `
                                        <div class="unit-price">
                                            ${this.product.price_per_unit.unit}:
                                            ${this.product.price_per_unit.price.toFixed(this.decimalDigits)}
                                            ${this.currency}
                                        </div>
                                    `
                : ''}

                              <div class="price" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                                  <meta itemprop="priceCurrency" content="${this.currencyISO}" />
                                  <meta itemprop="sku" content="${sku}" />
                                  ${this.product.flags.green_point ? html ` <div class="green-point"></div> ` : ''}
                                  <div class="prices">
                                      ${this.product.catalog_price !== this.product.price
                ? html `
                                                <meta
                                                    itemprop="price"
                                                    content="${this.product.price.toFixed(this.decimalDigits)}"
                                                />
                                                <meta
                                                    itemprop="oldPrice"
                                                    content="${this.product.catalog_price.toFixed(this.decimalDigits)}>"
                                                />
                                                <span>
                                                    ${this.product.price.toFixed(this.decimalDigits)}
                                                    <span>${this.currency}</span>
                                                </span>
                                                <div>
                                                    <del>
                                                        ${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                        <span>${this.currency}</span>
                                                    </del>
                                                </div>
                                            `
                : html `
                                                <meta
                                                    itemprop="price"
                                                    content="${this.product.price.toFixed(this.decimalDigits)}"
                                                />
                                                <span>
                                                    ${this.product.price.toFixed(this.decimalDigits)}
                                                    <span>${this.currency}</span>
                                                </span>
                                            `}
                                  </div>
                                  ${discountPercentage > 0
                ? html `
                                            <div class="discount">
                                                <span>${discountPercentage < 0 ? '+' : '-'}${discountPercentage}%</span>
                                            </div>
                                        `
                : ''}
                                  ${this.product.availability.can_be_bought
                ? html ` <link itemprop="availability" href="http://schema.org/InStock" /> `
                : html ` <link itemprop="availability" href="http://schema.org/OutOfStock" /> `}
                              </div>
                          </div>
                          ${this.activeStore
                ? html ` <div class="cart-add-wrapper">
                                    ${this.product.availability.can_be_bought
                    ? html `
                                              <cart-add
                                                  logUrl="${ifDefined(this.logUrl === null ? undefined : this.logUrl)}"
                                                  sku="${sku}"
                                                  productID="${this.product.id}"
                                                  altshopID="${this.altshopID}"
                                              ></cart-add>
                                          `
                    : html ` <div class="unavailable"></div> `}
                                </div>`
                : ''}
                      </div>
                  `
            : ''}
        `;
    }
    goToProductPage(event) {
        event.preventDefault();
        if (this.product === null) {
            return;
        }
        const target = event.target;
        // Sprawdz czy nie kliknięto na koszyk
        if (target.closest('.cart-add-wrapper') !== null) {
            return;
        }
        window.location.href = this.product.navigation.alternate_url;
    }
    getImageUrl(product, requestedSize) {
        let path = '/img/ts.gif';
        product.main_image.sizes.forEach((size) => {
            if (size.size === requestedSize) {
                path = size.url;
            }
        });
        return path;
    }
    omnibusPercentage(previousPrice, price) {
        const percent = Math.ceil(100 - (Number(price) / previousPrice) * 100);
        let percentString = '';
        if (Math.abs(percent) > 0) {
            if (percent < 0) {
                percentString = '+' + Math.abs(percent) + '%';
            }
            else {
                percentString = '-' + Math.abs(percent) + '%';
            }
        }
        return percentString;
    }
    get activeColorName() {
        if (this.product === null || typeof this.product.attributes === 'undefined') {
            return '';
        }
        let name = '';
        this.product.attributes.forEach((attr) => {
            if (this.product !== null && attr.sku === this.product.variant_sku) {
                name = attr.attribute_name;
            }
        });
        return name;
    }
    get currency() {
        if (typeof window.__STATE__ === 'undefined') {
            return '';
        }
        return window.__STATE__.localization.currency;
    }
    get currencyISO() {
        if (typeof window.__STATE__ === 'undefined') {
            return '';
        }
        return window.__STATE__.localization.currency_iso;
    }
    get decimalDigits() {
        if (typeof window.__STATE__ === 'undefined') {
            return 2;
        }
        return window.__STATE__.localization.decimal_digits;
    }
    get activeStore() {
        if (typeof window.__STATE__ === 'undefined') {
            return false;
        }
        return window.__STATE__.functions.active_store;
    }
};
__decorate([
    property({ type: Object })
], ProductTileCompact.prototype, "product", void 0);
__decorate([
    property({ type: String })
], ProductTileCompact.prototype, "altshopID", void 0);
__decorate([
    property({ type: String })
], ProductTileCompact.prototype, "logUrl", void 0);
ProductTileCompact = __decorate([
    customElement('product-tile-compact')
], ProductTileCompact);
export default ProductTileCompact;
